var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('n-loader',{attrs:{"loading":_vm.$app.store.getter('app.load')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }